<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import Modal from '@/components/shared/Modal.vue'
import type { ReferenceConnection } from '@/models/api-generated'

const { t, te } = useI18n()
const open = defineModel<boolean>({ required: true })
defineProps<{ connections: ReferenceConnection[]; mode: 'view' | 'delete' }>()
const emit = defineEmits<{ confirm: [] }>()

function typeLabel(ownerType: string) {
	const key = `document.referenceTypes.${ownerType}`
	return te(key) ? t(key) : ownerType
}

function confirmDelete() {
	emit('confirm')
	open.value = false
}
</script>

<template>
	<Modal v-model="open" type="references">
		<template #header>
			<h5>{{ t('document.references.title') }}</h5>
		</template>
		<template #body>
			<p v-if="mode === 'delete'" class="text-danger">{{ t('document.references.deleteWarning') }}</p>
			<p v-if="!connections.length" class="text-muted mb-0">{{ t('document.references.empty') }}</p>
			<ul v-else class="list-unstyled mb-0">
				<li
					v-for="(conn, i) in connections"
					:key="`${conn.ownerType}-${conn.ownerId}-${i}`"
					class="d-flex align-items-center mb-1"
				>
					<span class="badge bg-secondary me-2">{{ typeLabel(conn.ownerType) }}</span>
					<span>{{ conn.name }}</span>
				</li>
			</ul>
		</template>
		<template #footer>
			<template v-if="mode === 'delete'">
				<button type="button" class="btn btn-secondary" @click="open = false">{{ t('misc.cancel') }}</button>
				<button type="button" class="btn btn-danger" @click="confirmDelete">{{ t('document.references.deleteAnyway') }}</button>
			</template>
			<button v-else type="button" class="btn btn-secondary" @click="open = false">{{ t('misc.close') }}</button>
		</template>
	</Modal>
</template>
